<script setup lang="ts">
/**
 * The header drawn where a grouped list's value changes, such as "Active". The
 * table and the card lists both use it, so a grouped list looks the same in each.
 */
defineProps<{
  label: string;
}>();
</script>

<template>
  <div
    data-testid="list-group-header"
    class="rounded-lg border bg-secondary px-3 py-1.5 text-xs font-semibold tracking-tight text-secondary-foreground/80"
  >
    {{ label }}
  </div>
</template>
